import React, { useEffect, useRef, useState } from 'react';
import QRCode from 'qrcode';
import { api, attendanceApi } from '../../services/api';
import { useToast } from '../../components/ui/use-toast';
import { Button } from '../../components/ui/button';
import { Building2, Users, RefreshCw } from 'lucide-react';

// Kiosk: 3 dk'da bir yenilenen QR. İdari için tek; Saha için ekip bazlı.
const AttendanceKioskPage = () => {
  const { toast } = useToast();
  const [teams, setTeams] = useState([]);
  const [scope, setScope] = useState('idari');
  const [qrImg, setQrImg] = useState('');
  const [remaining, setRemaining] = useState(0);
  const tickRef = useRef(null);

  useEffect(() => {
    api.get('/teams').then((r) => setTeams(r.data?.data || [])).catch(() => {});
  }, []);

  const loadQr = async (sc) => {
    try {
      const res = await attendanceApi.getQr(sc);
      const { token, expiresAt } = res.data?.data || {};
      const checkinUrl = `${window.location.origin}/checkin?token=${encodeURIComponent(token)}`;
      const img = await QRCode.toDataURL(checkinUrl, { width: 320, margin: 1 });
      setQrImg(img);
      setRemaining(Math.max(0, Math.round((expiresAt - Date.now()) / 1000)));
    } catch (e) {
      toast({ title: 'Hata', description: 'QR alınamadı', variant: 'destructive' });
    }
  };

  // scope değişince + her saniye sayaç; süre bitince yenile
  useEffect(() => {
    loadQr(scope);
    /* eslint-disable-next-line */
  }, [scope]);

  useEffect(() => {
    tickRef.current = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          loadQr(scope);
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(tickRef.current);
    /* eslint-disable-next-line */
  }, [scope]);

  const mmss = `${String(Math.floor(remaining / 60)).padStart(2, '0')}:${String(remaining % 60).padStart(2, '0')}`;
  const scopeLabel = scope === 'idari' ? 'İdari' : teams.find((t) => `team:${t.id}` === scope)?.code || 'Ekip';

  return (
    <div className="min-h-[80vh] flex flex-col items-center">
      <div className="w-full max-w-3xl">
        <h1 className="text-2xl font-bold text-slate-900 mb-1">QR Yoklama Kiosk</h1>
        <p className="text-sm text-slate-500 mb-6">
          Personel telefonuyla bu QR'ı okutarak giriş/çıkış yapar. Kod her 3 dakikada yenilenir.
        </p>

        {/* Scope seçimi */}
        <div className="flex flex-wrap gap-2 mb-6">
          <button
            onClick={() => setScope('idari')}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium ${
              scope === 'idari' ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
          >
            <Building2 className="h-4 w-4" /> İdari
          </button>
          {teams.map((t) => (
            <button
              key={t.id}
              onClick={() => setScope(`team:${t.id}`)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium ${
                scope === `team:${t.id}` ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}
            >
              <Users className="h-4 w-4" /> {t.code}
            </button>
          ))}
        </div>

        {/* QR kartı */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-8 flex flex-col items-center">
          <div className="text-center mb-4">
            <p className="text-xs uppercase tracking-wider text-slate-400">Yoklama Noktası</p>
            <p className="text-xl font-bold text-blue-700">{scopeLabel}</p>
          </div>
          {qrImg ? (
            <img src={qrImg} alt="Yoklama QR" className="w-72 h-72" />
          ) : (
            <div className="w-72 h-72 bg-slate-100 rounded-lg animate-pulse" />
          )}
          <div className="mt-5 flex items-center gap-3">
            <div className="text-3xl font-mono font-bold text-slate-800">{mmss}</div>
            <Button variant="outline" size="sm" onClick={() => loadQr(scope)}>
              <RefreshCw className="h-4 w-4 mr-1.5" /> Yenile
            </Button>
          </div>
          <p className="text-xs text-slate-400 mt-2">Kalan süre dolduğunda QR otomatik yenilenir.</p>
        </div>
      </div>
    </div>
  );
};

export default AttendanceKioskPage;
